<template>
  <woot-modal :show.sync="show" :on-close="onClose">
    <div class="contact-block-modal">
      <h2 class="modal-title">
        {{
          blocked
            ? $t('BLOCK_CONTACT_MODAL.TITLE.UNBLOCK')
            : $t('BLOCK_CONTACT_MODAL.TITLE.BLOCK')
        }}
      </h2>

      <div class="modal-content">
        <div class="warning-title">
          🔒

          <span>
            {{
              blocked
                ? $t('BLOCK_CONTACT_MODAL.WARNING_TITLE.UNBLOCK')
                : $t('BLOCK_CONTACT_MODAL.WARNING_TITLE.BLOCK')
            }}
          </span>
        </div>

        <template v-if="blocked">
          <p class="highlight-text">
            {{ $t('BLOCK_CONTACT_MODAL.CONTENT.UNBLOCK.HIGHLIGHT') }}
          </p>

          <p>
            {{ $t('BLOCK_CONTACT_MODAL.CONTENT.UNBLOCK.DESCRIPTION') }}
          </p>
        </template>

        <template v-else>
          <p class="highlight-text">
            {{ $t('BLOCK_CONTACT_MODAL.CONTENT.BLOCK.HIGHLIGHT') }}
          </p>

          <p>
            {{ $t('BLOCK_CONTACT_MODAL.CONTENT.BLOCK.DESCRIPTION') }}
          </p>

          <p class="examples-title">
            {{ $t('BLOCK_CONTACT_MODAL.CONTENT.BLOCK.EXAMPLES_TITLE') }}
          </p>

          <ul class="warning-list">
            <li>
              {{ $t('BLOCK_CONTACT_MODAL.CONTENT.BLOCK.EXAMPLES.SPAM') }}
            </li>

            <li>
              {{
                $t('BLOCK_CONTACT_MODAL.CONTENT.BLOCK.EXAMPLES.INAPPROPRIATE')
              }}
            </li>

            <li>
              {{ $t('BLOCK_CONTACT_MODAL.CONTENT.BLOCK.EXAMPLES.REPETITIVE') }}
            </li>

            <li>
              {{ $t('BLOCK_CONTACT_MODAL.CONTENT.BLOCK.EXAMPLES.SCAM') }}
            </li>

            <li>
              {{
                $t(
                  'BLOCK_CONTACT_MODAL.CONTENT.BLOCK.EXAMPLES.SUSPICIOUS_LINKS'
                )
              }}
            </li>
          </ul>
        </template>
      </div>

      <div class="modal-actions">
        <woot-button color-scheme="alert" @click="onConfirm">
          {{
            blocked
              ? $t('BLOCK_CONTACT_MODAL.ACTION.UNBLOCK', {
                  name: contactDisplayName,
                })
              : $t('BLOCK_CONTACT_MODAL.ACTION.BLOCK', {
                  name: contactDisplayName,
                })
          }}
        </woot-button>

        <button type="button" class="cancel-button" @click="onClose">
          {{ $t('BLOCK_CONTACT_MODAL.ACTION.CANCEL') }}
        </button>
      </div>
    </div>
  </woot-modal>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },

    contact: {
      type: Object,
      required: true,
    },

    blocked: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    contactDisplayName() {
      const name =
        this.contact?.name ||
        this.contact?.phone_number ||
        this.$t('BLOCK_CONTACT_MODAL.DEFAULT_CONTACT');

      const firstName = name.trim().split(' ')[0];

      return firstName.slice(0, 20);
    },
  },

  methods: {
    onClose() {
      this.$emit('update:show', false);
      this.$emit('close');
    },

    onConfirm() {
      this.$emit('confirm');
    },
  },
};
</script>

<style scoped lang="scss">
.contact-block-modal {
  padding: 2rem;
  max-width: 760px;
}

.modal-title {
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.2;
  margin: 0 0 1rem;
}

.warning-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.65rem;
  font-weight: 700;
  line-height: 1.4;
  margin-bottom: 1rem;
}

.modal-content {
  max-width: 64rem;
  font-size: 1.35rem;
  line-height: 1.7;
  p {
    margin: 0 0 1rem;
  }
  p:last-child {
    margin-bottom: 0;
  }
}

.highlight-text {
  font-size: 1.45rem;
  font-weight: 700;
  line-height: 1.5;
}

.examples-title {
  margin-top: 1.5rem;
  margin-bottom: 0.75rem;
  font-size: 1.35rem;
  font-weight: 600;
}

.warning-list {
  margin: 0 0 0 2rem;
  font-size: 1.3rem;
  li {
    margin-bottom: 0.65rem;
    line-height: 1.65;
    &:last-child {
      margin-bottom: 0;
    }
  }
}

.modal-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-top: 1.5rem;
  ::v-deep .button {
    max-width: 420px;
  }
  ::v-deep .button__content {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    text-align: center;
    line-height: 1.4;
  }
}

.cancel-button {
  background: transparent;
  border: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 0;
  cursor: pointer;
  color: #1d4ed8;
  font-size: 1.3rem;
  font-weight: 600;
  line-height: 1;
  &:hover {
    text-decoration: underline;
  }
}
</style>
